

































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Offer } from '@/api/model/offer'
import { OfferAPI } from '@/api/backend-client'
import { ProductType } from '@/api/types'
import { Product } from '@/api/model/product'

@Component
export default class MarketplaceDetail extends Vue {
    @Prop({ required: true }) offerId!: string
    offer: Offer = null
    loading: boolean = false
    submitting: boolean = false
    submitted: boolean = false
    showDetails: boolean = false

    async mounted(): Promise<void> {
        await this.loadOffer()
    }

    async showDetailsModal(): Promise<void> {
        this.showDetails = true
    }

    async loadOffer(): Promise<void> {
        this.loading = true
        this.offer = await OfferAPI.get(this.offerId)
        this.loading = false
    }

    async requestOffer(offer: Offer): Promise<void> {
        try {
            this.submitting = true
            await OfferAPI.requestOffer({
                offer,
                user: this.$currentUser,
            })
            this.submitted = true

        } finally {
            this.submitting = false
        }
    }

    generateMailToLink(offer: Offer): string {
        return `mailto:vraag@marketingperron.nl` +
            `?subject=Vraag over pakket '${offer.name}' in KeyVue`
    }

    calculatePriceForProducts(products: Product[]): number {
        return products
            .filter(product => product.included)
            .reduce((a, b) => a + b.price, 0)
    }

    /**
     * List of all products with upfront payment that are non-optional.
     */
    get productsOnce(): Product[] {
        return !this.offer ? [] : this.offer.products
            .filter(product => product.type === ProductType.TYPE_ONCE)
            .filter(product => product.optional === false)
            .sort((a, b) => a.name.localeCompare(b.name))
    }

    /**
     * List of all products with recurring costs that are non-optional.
     */
    get productsRecurring(): Product[] {
        return !this.offer ? [] : this.offer.products
            .filter(product => product.type !== ProductType.TYPE_ONCE)
            .filter(product => product.optional === false)
            .sort((a, b) => a.name.localeCompare(b.name))
    }

    /**
     * List of all products that are optional.
     */
    get productsOptional(): Product[] {
        return !this.offer ? [] : this.offer.products
            .filter(product => product.optional === true)
            .sort((a, b) => a.name.localeCompare(b.name))
    }

    totalPriceForType(type: ProductType): number {
        if (!this.offer) {
            return 0
        }

        return this.offer.products
            .filter(product => product.type === type)
            .filter(product => product.included)
            .reduce((a, b) => a + b.price, 0)
    }

    get priceMonthly(): number {
        return this.totalPriceForType(ProductType.TYPE_MONTHLY)
    }

    get priceYearly(): number {
        return this.totalPriceForType(ProductType.TYPE_YEARLY)
    }

    get priceOnce(): number {
        return this.totalPriceForType(ProductType.TYPE_ONCE)
    }

    get priceRecurring(): number {
        return this.calculatePriceForProducts(this.productsRecurring)
    }

    get priceOptional(): number {
        return this.calculatePriceForProducts(this.productsOptional)
    }

    get hasProductsOnce(): boolean {
        return this.productsOnce.length > 0
    }

    get hasProductsRecurring(): boolean {
        return this.productsRecurring.length > 0
    }

    get hasProductsOptional(): boolean {
        return this.productsOptional.length > 0
    }

    get columnCount(): number {
        let count = 3

        if (this.hasProductsOnce === false) {
            count--
        }

        if (this.hasProductsRecurring === false) {
            count--
        }

        if (this.hasProductsOptional === false) {
            count--
        }

        return count
    }
}
